import { render } from "./CandlesCarousel.vue?vue&type=template&id=0a03b517&scoped=true&lang=html"
import script from "./CandlesCarousel.vue?vue&type=script&lang=js"
export * from "./CandlesCarousel.vue?vue&type=script&lang=js"

import "./CandlesCarousel.vue?vue&type=style&index=0&id=0a03b517&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a03b517"]])

export default __exports__